import { API_ENDPOINTS, API_HEADERS } from "../constants/api";

export interface LearningPackagePayload {
  id?: number;
  eng_title: string;
  ch_title: string;
  published_date: string;
  file_cover: string;
  file: string;
  [key: string]: unknown;
}

export const fetchLearningPackages = async (): Promise<LearningPackagePayload[]> => {
  const response = await fetch(API_ENDPOINTS.learningPackages, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(
      `Learning packages request failed with status ${response.status}`
    );
  }

  const data = await response.json();
  return Array.isArray(data) ? (data as LearningPackagePayload[]) : [];
};
